var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.5C0.5 2.33 1.17 3 2 3H5.5V13.5C5.5 14.33 6.17 15 7 15C7.83 15 8.5 14.33 8.5 13.5V3H12C12.83 3 13.5 2.33 13.5 1.5C13.5 0.67 12.83 0 12 0H2C1.17 0 0.5 0.67 0.5 1.5ZM18 5H12C11.17 5 10.5 5.67 10.5 6.5C10.5 7.33 11.17 8 12 8H13.5V13.5C13.5 14.33 14.17 15 15 15C15.83 15 16.5 14.33 16.5 13.5V8H18C18.83 8 19.5 7.33 19.5 6.5C19.5 5.67 18.83 5 18 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBlock);
export default __webpack_public_path__ + "static/media/TextBlock.53bd621406ba5bb49117d5472376669a.svg";
export { ForwardRef as ReactComponent };